// import "src/decidim/accountability/index" --deprecated

// Images
require.context("../images", true)

// CSS
import "stylesheets/accountability.scss"
